import uuid from 'uuid-random';
import { addPopupAction, LAYER } from 'js/components/common/PopupManager';

import { GamblingSessionLimitsPopup } from '../GamblingSessionLimitsPopup';

const popupId = uuid();

export const showGamblingSessionLimitsPopupAction = (
    { onSuccessLimitsSet }: { onSuccessLimitsSet?: () => void }
) => addPopupAction({
    id: popupId,
    isModal: true,
    onSuccessLimitsSet,
    layer: LAYER.GAMBLING_SESSION,
    component: GamblingSessionLimitsPopup
});
